export default __webpack_public_path__ + "static/media/screen_livechat_18.1b4b09ab.png";